import DeleteChatModal from '../DeleteChatModal/DeleteChatModal';

export default DeleteChatModal;